// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1fvdglyw button:not([disabled]):after{border:none}._18u0idpf{margin-left:0}
._1e0c1txw{display:flex}
._1ul91wug{min-width:auto}
._1ylx1txw >div>div{display:flex}
._4cvr1h6o{align-items:center}
._p7r11txw >div, ._1xdi1txw >span{display:flex}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/editor-common/dist/esm/ui/Toolbar/DropdownWrapper.compiled.css"],"names":[],"mappings":";AACA,wCAAwC,WAAW,CAAC,WAAW,aAAa;AAC5E,WAAW,YAAY;AACvB,WAAW,cAAc;AACzB,oBAAoB,YAAY;AAChC,WAAW,kBAAkB;AAC7B,kCAAkC,YAAY","sourcesContent":["\n._1fvdglyw button:not([disabled]):after{border:none}._18u0idpf{margin-left:0}\n._1e0c1txw{display:flex}\n._1ul91wug{min-width:auto}\n._1ylx1txw >div>div{display:flex}\n._4cvr1h6o{align-items:center}\n._p7r11txw >div, ._1xdi1txw >span{display:flex}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
